// extracted by mini-css-extract-plugin
export default {"loading-shimmer":"swH4hNTMxonjskMsYzIfuQ==","shimmer":"lCR-tdd+3349CDOGqBw9lg=="};